import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Route, Clock } from "lucide-react";
import StageAnalysisPanel from "@/components/StageAnalysisPanel";
import PageTimeAnalytics from "@/components/PageTimeAnalytics";

// @origin: v2 | @since: 3d9ebf6d | @used-by: ALL | @purpose: 2f port -- tabbed
// shell hosting the Stage Analysis and Page Time Analytics panels. Ported
// verbatim from donor tip (5fe70ff4); no backend/model dependency of its own.
const JourneyStageAnalytics: React.FC = () => {
	return (
		<Card className="border-intellend-green/10 shadow-sm overflow-hidden">
			<CardHeader className="p-4 pb-2.5 border-b bg-gray-50/30">
				<CardTitle className="text-xl font-semibold">Stage &amp; Page Analytics</CardTitle>
			</CardHeader>
			<CardContent className="p-4 sm:p-6">
				<Tabs defaultValue="stage-analysis" className="w-full">
					<TabsList className="mb-6">
						<TabsTrigger value="stage-analysis" className="gap-1.5">
							<Route className="h-4 w-4" />
							Stage Analysis
						</TabsTrigger>
						<TabsTrigger value="page-time" className="gap-1.5">
							<Clock className="h-4 w-4" />
							Page Time Analytics
						</TabsTrigger>
					</TabsList>

					<TabsContent value="stage-analysis" className="mt-0">
						<StageAnalysisPanel />
					</TabsContent>

					<TabsContent value="page-time" className="mt-0">
						<PageTimeAnalytics />
					</TabsContent>
				</Tabs>
			</CardContent>
		</Card>
	);
};

export default JourneyStageAnalytics;
